import React from 'react';

// Sample Logos (You can replace these URLs with your actual partner logos)
const partners = [
  { name: 'Asian Paints', logo: 'https://www.freelogovectors.net/wp-content/uploads/2023/01/asian-paints-logo-freelogovectors.net_.png' },
  { name: 'Jaquar', logo: 'https://logos-world.net/wp-content/uploads/2021/03/Jaguar-Logo-1945-2001.png' }, 
  { name: 'Kohler', logo: 'https://images.all-free-download.com/images/graphiclarge/kohler_logo_29554.jpg' },
  { name: 'Havells', logo: 'https://logos-world.net/wp-content/uploads/2023/03/Havells-Logo.png' },
  { name: 'Saint Gobain', logo: 'https://download.logo.wine/logo/Saint-Gobain/Saint-Gobain-Logo.wine.png' },
  { name: 'Hafele', logo: 'http://dienmaytientrung.com/uploads/menu/logo_hafele.png' },
];

const TrustedPartners = () => {
  return (
    <div className="bg-white py-16 border-t border-gray-200 overflow-hidden font-sans">
      
      {/* CSS for infinite scroll animation */}
      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-6 mb-12 text-center">
        <span className="text-amber-600 tracking-[0.2em] text-xs font-bold uppercase mb-2 block">
          Uncompromised Quality
        </span>
        <h2 className="text-2xl md:text-3xl font-serif text-neutral-900">
          Premium Brands We Use 
        </h2>
      </div>

      {/* Infinite Slider Container */}
      <div className="relative w-full overflow-hidden">
        
        {/* Gradients to fade edges - White color match */}
        <div className="absolute top-0 left-0 h-full w-24 bg-gradient-to-r from-white to-transparent z-10"></div>
        <div className="absolute top-0 right-0 h-full w-24 bg-gradient-to-l from-white to-transparent z-10"></div>

        {/* Moving Track */}
        <div className="flex items-center gap-16 md:gap-24 w-max animate-scroll">
          
          {/* First Set of Logos */}
          {partners.map((partner, index) => (
            <div 
              key={`logo-1-${index}`} 
              className="flex items-center justify-center w-32 md:w-40 cursor-pointer hover:scale-110 transition-transform duration-300"
            >
              <img 
                src={partner.logo} 
                alt={`${partner.name} - Luxury Interior Partner in Lucknow & Varanasi`} // Keyword Rich Alt Text
                className="max-h-16 w-auto object-contain" 
              />
            </div>
          ))}

          {/* Duplicate Set of Logos (For seamless looping) */}
          {partners.map((partner, index) => (
            <div 
              key={`logo-2-${index}`} 
              className="flex items-center justify-center w-32 md:w-40 cursor-pointer hover:scale-110 transition-transform duration-300"
            >
              <img 
                src={partner.logo} 
                alt={`${partner.name} - Best Quality Material for Home Renovation`} // Keyword Rich Alt Text
                className="max-h-16 w-auto object-contain" 
              />
            </div>
          ))}

          {/* Triplicate Set of Logos (For safety on wide screens) */}
          {partners.map((partner, index) => (
            <div 
              key={`logo-3-${index}`} 
              className="flex items-center justify-center w-32 md:w-40 cursor-pointer hover:scale-110 transition-transform duration-300"
            >
              <img 
                src={partner.logo} 
                alt={`${partner.name} - Trusted Brand used by Luxuriya Homes`} // Keyword Rich Alt Text
                className="max-h-16 w-auto object-contain" 
              />
            </div>
          ))}

        </div>
      </div>
    </div>
  );
};

export default TrustedPartners;